import React from "react";
import { Helmet } from "react-helmet";
import ResourcesCommonComponent from "./ResourcesCommonComponent";
import { resourcesServices } from "../../services/resourcesService";
import { defer } from "react-router-dom";

const ConsellingService = () => {
  return (
    <div>
      <Helmet>
        <title>Counselling Service Providers - Cope With Cancer</title>

        <meta
          name="description"
          content="Helpline iCALL- 022 25563291 Mon to Sat 10am to 10pm team comprises of trained counselling psychologists; Aasra Helpline - 24 Hour Helpline - 022-27546669."
        />
        <meta name="robots" content="noodp" />
        <link
          rel="canonical"
          href="https://www.copewithcancer.org/counseling-service-providers"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Counselling Service Providers - Cope With Cancer"
        />
        <meta
          property="og:description"
          content="Helpline iCALL- 022 25563291 Mon to Sat 10am to 10pm team comprises of trained counselling psychologists; Aasra Helpline - 24 Hour Helpline - 022-27546669."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/counseling-service-providers"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="Helpline iCALL- 022 25563291 Mon to Sat 10am to 10pm team comprises of trained counselling psychologists; Aasra Helpline - 24 Hour Helpline - 022-27546669."
        />
        <meta
          name="twitter:title"
          content="Counselling Service Providers - Cope With Cancer"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-06-06T11:54:26+00:00" />
      </Helmet>

      <div className="topspace">
        <div className="text-center">
          <div className="conunselling"><div className="bannertitleNew">Counseling Service Providers</div></div>
          {/* <img
            src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/conunselling_banner-1-1024x193.jpg"
            alt="What is Cancer"
            className="w-100"
          ></img> */}
          <h1 className="bannertitle displayNone">Counseling Service Providers</h1>
        </div>
        <div className="contentBox">
          <div className="container">
            <h3 className="Bold28 mb20">Counseling Service Providers</h3>

            <table className="mb20">
              <tr>
                <td className="Bold18">Helpline iCALL</td>
              </tr>
              <tr>
                <td className="Bold14">
                  022 25563291 | Monday to Saturday 10am to 10pm
                </td>
              </tr>
              <tr>
                <td className="p150 pb0">
                  iCALL which stands for Initiating Concern for All is an
                  initiative of Center for Human Ecology , Tata Institute of
                  Social Sciences, Mumbai. It is a tel-counseling service aimed
                  at providing emotional support and psychotherapy to
                  individuals in emotional and psychological distress. iCALL
                  team comprises of trained counselling psychologists who have
                  at least a Master’s degree in Psychology. The counselors speak
                  in English, Hindi, Marathi and additionally at least one
                  counselor speaks in Gujarati, Punjabi, Sindhi, Malayalam and
                  Tamil each.
                </td>
              </tr>
            </table>

            <table className="mb20">
              <tr>
                <td className="Bold18">Aasra Helpline</td>
              </tr>
              <tr>
                <td className="Bold14">
                  24 Hour Helpline: 022-27546669, Johnson Thomas : 9820466726
                </td>
              </tr>
            </table>

            <ResourcesCommonComponent senderComponent="Accomodation" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConsellingService;

const getResource = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : "?pageNumber=1&city=mumbai&state=maharashtra&location";
    console.log(searchParams);
    const resource = "counselingServiceProvider";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getResources(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return {
      resources: responce.data.ResponseObject,
      totalRecords: responce.data.TotalRecords,
    };
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getLocation = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : null;
    console.log(searchParams);
    const resource = "counselingServiceProvider";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getLocations(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return responce.data.ResponseObject;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const loader = async ({ request, params }) => {
  return defer({
    data: await getResource({ request, params }),
    locations: await getLocation({ request, params }),
  });
};
